import { DeleteOutlined, StarOutlined } from '@ant-design/icons'
import { Badge, Button, Card, Tooltip } from 'antd'
import { GalleryItem as GalleryItemModel } from '../../models/GalleryItem'
import { Permission } from '../../utils/permissions'
import { useHasAccess } from '../HasAccess'

interface Props {
  picture?: GalleryItemModel
  style?: React.CSSProperties
  onSetFeaturedClicked?: () => void
  onDeleteClicked?: () => void
}

const GalleryItem = ({
  picture,
  style,
  onSetFeaturedClicked = undefined,
  onDeleteClicked = undefined,
}: Props) => {
  if (!picture) {
    return <>Picture not found</>
  }
  const { hasAccess } = useHasAccess()

  const image = (
    <Card
      styles={{ body: { padding: 10 } }}
      style={{
        border: picture.isFeatured ? '4px solid #8e978a' : '',
        ...style,
      }}
    >
      <div
        style={{
          width: '100%',
          aspectRatio: 16 / 9,
          backgroundPosition: 'center',
          backgroundImage: `url(${picture.url})`,
          backgroundSize: 'cover',
        }}
      >
        {!picture.isFeatured && hasAccess(Permission.updateVenue) && (
          <Button
            style={{ position: 'absolute', bottom: 15, right: 15 }}
            type="primary"
            danger
            color="red"
            size="small"
            icon={<DeleteOutlined />}
            onClick={() => onDeleteClicked && onDeleteClicked()}
          />
        )}
      </div>
    </Card>
  )
  return onSetFeaturedClicked ? (
    <Badge
      className="w-full"
      dot
      count={
        <Tooltip title={'Set as featured'}>
          <StarOutlined
            style={{
              color: 'white',
              cursor: hasAccess(Permission.updateVenue) ? 'pointer' : 'default',
              padding: 5,
              background: picture.isFeatured ? '#8e978a' : 'grey',
              borderRadius: '50%',
              textAlign: 'center',
            }}
            onClick={() =>
              hasAccess(Permission.updateVenue) ? onSetFeaturedClicked() : null
            }
          />
        </Tooltip>
      }
      offset={[-5, 5]}
    >
      {image}
    </Badge>
  ) : (
    image
  )
}

type GalleryItemType = { Item: typeof GalleryItem }

export { GalleryItem, type GalleryItemType }
